import React from 'react';
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import CourseOperate from '../../Shared/Courses/CourseOperate';
import Cloud from '../../../img/Course-Elements/Cloud.png';

const CloudComputing = () => {
    return (
        <div className='px-4 md:px-12 pt-10'>
            <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
            <h1 className='text-blue-500 text-4xl font-semibold my-4'>Cloud <span className='text-orange-400'>Computing</span></h1>
            <h1 className='text-4xl font-semibold my-4'> </h1>
            <h2 className=''>To be an expert in cloud computing, learn about cloud principles, AWS services, security, architecture, pricing, and support.</h2>
            <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
            <h5>Offer: Get flat Rs.200 off oby applying the promo code CAREERHikers</h5>
            <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
            <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
            <CourseHighlights />
            <div className='flex mb-8 mt-12'>
                <div className='flex-1 md:mr-4'>
                    <h1 className='text-3xl font-semibold mb-6'>Why should study cloud computing?</h1>
                    <h2 className='text-xl my-2'>have high demand</h2>
                    <p>Cloud computing is now an essential component of any successful organisation and is no longer a choice. Therefore, to be a high performance, regardless of whether you work as a programmer, tester, or in any other IT function, you need cloud capabilities.</p>
                    <h1 className='text-2xl my-2'>a lucrative wage</h1>
                    <h3>According to Glassdoor, the typical pay for AWS Architect positions is 7.9LPA+.</h3>
                    <h1 className='text-xl my-2'>The future is now.</h1>
                    <p className='text-sm'>Cloud computing is enabling the future's online streaming, e-commerce, machine learning, internet of things, and more.</p>
                </div>
                <img className='flex-1' src={Cloud} alt="" />
            </div>
            <CourseOperate />
        </div>
    );
};

export default CloudComputing;